import { render } from "./SearchWidgetCustomElement.vue?vue&type=template&id=4ba99298&scoped=true"
import script from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"
export * from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"

import "./SearchWidgetCustomElement.vue?vue&type=style&index=0&id=4ba99298&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src120626721/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba99298"]])

export default __exports__